import { Box, Button, Paper, TextField, Typography } from "@mui/material";
import { getCustomOrderById_req } from "../api/all.api";
import { useState } from "react";

const exampleJSON = {
  orderId: "ORD-1234",
  status: "Complete",
  amount: 120.5,
};

function JsonViewer() {
  const [orderId, setOrderId] = useState("");
  const [jsonData, setJsonData] = useState(null);
  const [errorText, setErrorText] = useState("");
  console.log("orderId", orderId);

  const getCustomOrderById = async () => {
    try {
      const response = await getCustomOrderById_req(orderId);
      console.log("response", response);
      setErrorText("");
      setJsonData(response);
    } catch (e) {
      console.log("e", e);
      setJsonData(null);
      setErrorText("Please write correct Order Id");
    }
  };

  return (
    <Paper sx={{ p: 2 }}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
          width: 450,
          marginBottom: 3,
        }}
      >
        <Typography>Order ID </Typography>
        <TextField
          label="Order ID contains"
          value={orderId}
          onChange={(e) => setOrderId(e.target.value)}
        />

        <Button
          variant="contained"
          onClick={getCustomOrderById}
        >
          View Report
        </Button>
      </Box>
      {errorText && (
        <Typography
          color="error"
          sx={{ mb: 2 }}
        >
          {errorText}
        </Typography>
      )}
      {jsonData && (
        <Box sx={{ backgroundColor: "#f4f4f4" }}>
          <Typography
            variant="body1"
            component="pre"
          >
            {JSON.stringify(jsonData, null, 2)}
          </Typography>
        </Box>
      )}
    </Paper>
  );
}

export default JsonViewer;
